import axios from 'axios'

const Api_Key = process.env.REACT_APP_CONTENT_API_KEY
const BASE_URL = process.env.REACT_APP_API_CONTENT_URL
const utpKey = process.env.REACT_APP_CONTENT_API_UTP_KEY
const wwhKey = process.env.REACT_APP_CONTENT_API_WWH_KEY
const ptpKey = process.env.REACT_APP_CONTENT_API_PTP_KEY

let APIKit = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
})

APIKit.interceptors.request.use(
  (config) => {
    let apiKey = Api_Key
    const isOldAccount = sessionStorage.getItem('isOldAccount') === 'true'
    const webId = sessionStorage.getItem('webId')
    const isMatch = [
      '/lst_sectionindex',
      '/lst_committments',
      '/lst_section',
      '/lst_exerciseA',
      '/lst_exerciseB',
      '/lst_exerciseC',
      '/lst_exerciseD',
      '/lst_feedback',
      '/lst_conclusion',
    ].some((path) => config.url?.includes(path))
    if (isMatch && isOldAccount && webId === 'UTP') {
      apiKey = utpKey
    } else if (isMatch && isOldAccount && webId === 'WWH') {
      apiKey = wwhKey
    } else if (isMatch && isOldAccount && webId === 'PTP') {
      apiKey = ptpKey
    }

    config.headers['api_key'] = apiKey
    return config
  },
  (error) => Promise.reject(error),
)

export default APIKit
